import { withMock, HmRequestOptions } from '../../../http';
import resourceHttp from '../../../resourceHttp';

export const url = resourceHttp.url('/search/applications');

export const searchApplications = (searchTerm, options: HmRequestOptions = {}) =>
  withMock(url, options, () => import(/* webpackChunkName: "mockApi" */ './withmatch.mock.json'))
    .url(`?searchTerm=${searchTerm}`)
    .get();
